<template>
  <div id="app" class="">
    <NavBar />
    <div class="container mx-auto ">
      <Transition name="route">
        <router-view />
      </Transition>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/Navbar.vue";

export default {
  components: {
    NavBar
  }
};
</script>

<style src="./assets/css/tailwind.css"></style>
